import { init } from './init';

const krakenConfig = window.kraken;
__webpack_public_path__ = krakenConfig.productConfig.publicPath; // eslint-disable-line camelcase, no-undef

window.WHCore = window.WHCore || {};
window.WHCore.header = window.WHCore.header || {};

init({
  krakenConfig,
}).then(() => {
  // Initialization complete
}).catch(console.error);
